import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Linkedin, Facebook, Instagram, Music2, MessageCircle } from "lucide-react";
export default function HeroBanner() {
  const socialLinks = [{
    name: "LinkedIn",
    icon: Linkedin,
    url: "https://wa.me/526149800517",
    colorClass: "bg-chart-3 text-white hover:bg-chart-3/90"
  }, {
    name: "Facebook",
    icon: Facebook,
    url: "https://wa.me/526149800517",
    colorClass: "bg-chart-3 text-white hover:bg-chart-3/90"
  }, {
    name: "Instagram",
    icon: Instagram,
    url: "https://wa.me/526149800517",
    colorClass: "bg-chart-5 text-white hover:bg-chart-5/90"
  }, {
    name: "TikTok",
    icon: Music2,
    url: "https://wa.me/526149800517",
    colorClass: "bg-foreground text-background hover:bg-foreground/90"
  }];
  return <section id="hero-banner" className="relative w-full h-[600px] md:h-[700px] overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/hero_bg_workers.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/hero_bg_workers.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/hero_bg_workers.png-wvc-sizes" alt="Trabajadores de construcción" className="w-full h-full object-cover" loading="lazy" decoding="async" />
      </div>

      {}
      <div className="absolute inset-0 z-10 bg-primary/90" style={{
      clipPath: "polygon(25% 0, 100% 0, 100% 100%, 0 100%, 15% 50%)"
    }} />

      {}
      <div className="absolute inset-0 z-10 opacity-20 pointer-events-none" style={{
      backgroundImage: "radial-gradient(circle, #ffffff 1px, transparent 1px)",
      backgroundSize: "4px 4px"
    }} />

      {}
      <div className="relative z-20 flex flex-col items-center justify-center h-full px-6 text-center max-w-4xl mx-auto">
        <Link to="/" className="mb-8 transition-transform hover:scale-105">
          
        </Link>
        
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/mmmmmmmm.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/mmmmmmmm.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/mmmmmmmm.png-wvc-sizes" alt="Kalisch Steel Industrial" className="w-full max-w-md h-auto mb-6 rounded-lg shadow-lg" loading="lazy" decoding="async" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/k.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/nijnirjnriejerergerg.png" />

        <p className="text-primary-foreground text-lg md:text-2xl font-default font-medium leading-relaxed max-w-2xl text-balance drop-shadow-md">
          Empresa Mexicana líder en la comercialización de acero, ferretería y servicios de habilitados con 44 sucursales en 8 estados de la República Mexicana y USA.
        </p>
      </div>

      {}
      <div className="absolute right-0 top-1/2 -translate-y-1/2 z-30 flex flex-col shadow-lg">
        {socialLinks.map((social, i) => {
        const Icon = social.icon;
        return <Link key={social.name} to={social.url} newTab data-index={i} className={`w-10 h-10 md:w-12 md:h-12 flex items-center justify-center transition-colors ${social.colorClass}`} aria-label={`Visitar nuestro perfil en ${social.name}`}>
              <Icon className="w-5 h-5 md:w-6 md:h-6" />
            </Link>;
      })}
      </div>

      {}
      <div className="fixed bottom-6 right-6 z-50">
        <Button asChild size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground shadow-xl rounded-lg h-14 px-6 gap-3">
          <Link to="https://es.wikipedia.org/wiki/GayTACTANOS" newTab>
            <MessageCircle className="w-6 h-6" />
            <span className="font-default font-semibold text-base hidden md:inline-block">
              Contáctanos
            </span>
          </Link>
        </Button>
      </div>
    </section>;
}